// @flow
import React from "react";
import * as colors from "src/styles/constants/colors";

type Props = {
  width?: number,
  height?: number,
  color?: string
};

const CircularCheck = ({
  width = 20,
  height = 20,
  color = colors.grey42
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21.801 10A10 10 0 1 1 17 3.335" />
    <path d="m9 11 3 3L22 4" />
  </svg>
);

export default CircularCheck;
